import { useTrialAutoStart } from "@/hooks/useBilling";

/** Renders nothing; starts the trial (useTrialAutoStart) once the app is open. */
export function TrialAutoStart() {
  useTrialAutoStart();
  return null;
}
